"use client";

import Services from "@/views/services";

export default function Page() {
  return <Services />;
}
